module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_vm._l((_vm.frozenRevisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.progress.isRetaking || _vm.frozenRevisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _c('div', {
      staticClass: "revision__container revision__container--upload"
    }, _vm._l((revision.submissions), function(submission) {
      return _c('div', {
        staticClass: "submission submission--upload"
      }, [_c('a', {
        staticClass: "submission__thumb-link",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showImage(submission.data.medium)
          }
        }
      }, [_c('img', {
        staticClass: "submission__thumb",
        attrs: {
          "src": submission.data.thumb
        }
      })])])
    }))])
  }), (!_vm.readonly) ? _c('dropzone', {
    attrs: {
      "url": _vm.uploadUrl,
      "message": "Upload foto",
      "value": _vm.uploads,
      "extractResultFromResponse": _vm.extractResultFromUploadResponse,
      "maxNumberOfFiles": _vm.partial.data.max_files || 3
    },
    on: {
      "clicked": _vm.enlargeThumbnail,
      "success": _vm.storeSubmission,
      "removed": _vm.removeSubmission
    }
  }) : _vm._e(), (_vm.readonly && _vm.frozenRevisions.length === 0) ? _c('p', {
    staticClass: "revision__container revision__container--teacher"
  }, [_vm._v("Foto uploaden door leerling")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36c714a4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/UploadPartial.vue
// module id = YknS
// module chunks = 1